export default "__VITE_ASSET__JeghZMIj__"